import * as ReactDOM from 'react-dom/client';
import { Layout } from './layout.tsx';
import { StrictMode } from 'react';
import { Toaster } from 'react-hot-toast';
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, RouterProvider } from 'react-router-dom';
import { HomeView } from './view/home-view.tsx';
import { HomeRoute } from './view/route/home-route.tsx';
import { CreateRoute } from './view/route/create-route.tsx';
import { JoinRoute } from './view/route/join-route.tsx';
import { HowToPlay } from './view/how-to-play-view.tsx';
import { BugsFeaturesView } from './view/bugs-features-view.tsx';
import { WaitForAuthEffect } from './util/device-id';
import { GameView } from './view/route/game-view.tsx';
import { GameConfigureRoute } from './view/route/game-configure.tsx';
import { CheatsView } from './view/cheats-view.tsx';
// import { ThemeView } from './view/theme-view.tsx';
import { BackgroundPattern } from './components/pattern/background-pattern.tsx';

import './index.css';
import './locale/localization.ts';
import './util/device-id';
import './firebase/firebase-app';

const rootElement = document.getElementById('root') as HTMLElement;
const reactRoot = ReactDOM.createRoot(rootElement);

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path="/" element={<Layout />}>
            <Route element={<HomeView />} errorElement={<Navigate to="/" replace />}>
                <Route index element={<HomeRoute />} />
                <Route path="create" element={<CreateRoute />} />
                <Route path="join/:gameId?" loader={WaitForAuthEffect} element={<JoinRoute />} />
            </Route>
            <Route path="create/:gameId?" element={<GameConfigureRoute />} />
            <Route path="game/:gameId/*" loader={WaitForAuthEffect} element={<GameView />} />
            <Route path="rules" element={<HowToPlay />} />
            <Route path="bug-reports-features" element={<BugsFeaturesView />} />
            <Route path="cheats" element={<CheatsView />} />
            {/* {process.env['NODE_ENV'] === 'development' && <Route path="theme" element={<ThemeView />} />} */}
            <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
    )
);

reactRoot.render(
    <StrictMode>
        <Toaster />
        <BackgroundPattern />
        <RouterProvider router={router} />
    </StrictMode>
);
